<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <BookingTemplateForm
          ref="bookingTemplateForm"
          @onSubmit="createTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        @click.native="validateForm"
        :loading="isAddingBookingTemplate"
      >
        Create Role Template
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_BOOKING_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-booking-templates";
import { copyState } from "@/utils/helpers";
import { ADD_ORGANISATION_BOOKING_TEMPLATE } from "@/store/modules/organisations/organisation-booking-templates/actions";
import BookingTemplateForm from "@/views/settings/components/role-templates/components/BookingTemplateForm";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_BOOKING_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    BookingTemplateForm
  },
  computed: {
    ...mapState(copyState(["isAddingBookingTemplate"])),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Role Template"
      };
    }
  },
  methods: {
    ...mapActions({
      addBookingTemplate: ADD_ORGANISATION_BOOKING_TEMPLATE
    }),
    validateForm() {
      this.$refs.bookingTemplateForm.validateForm();
    },
    async createTemplate(bookingTemplateData) {
      await this.addBookingTemplate(bookingTemplateData);
      this.$emit("created");
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
